import React, { useContext,  useEffect,  useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { AlertContext, Alert_, Builder_, Dates_, PageAlwaysVisible, PageDesktopOnly, PageForty, PageIllu, PageSubtitle, PageTitle, Steps_Actions, Form } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { AuthContext } from '../../../../services/authentication/Guard';



const DATES = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const lang = store.getState().selectedLanguage ? store.getState().selectedLanguage : 'en';
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    const maxDate = new Date();
    const [renderedDates, setRenderedDates] = useState([]);
    const [dates, setDates] = useState({
        sinceDate: '',
        untilDate: '',
    });
    
    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };

    const saveAndNavigate = () => {
        store.dispatch({type: 'SAVE_GOOGLE_DATES', payload: dates});
        navigate(`/${lang}/google/create-report`);
    };

    const formatDate = (date) => {
        const localeDateFormat = new Intl.DateTimeFormat().formatToParts(new Date());

        const dateFormat = localeDateFormat.map((part) => {
            if (part.type === 'day') {
                return 'dd';
            } else if (part.type === 'month') {
                return 'mm';
            } else if (part.type === 'year') {
                return 'yyyy';
            }
            return part.value;
        }).join('/');
    

        let format = dateFormat.split('//');          

        let dateParts = date.toLocaleDateString().split('/');
        let formattedDate = [];

        let indexes = {month: -1, day: -1, year: -1};
        let counter = 0;
        for ( let part of format ) {
            if ( part.includes('dd') ) indexes.day = counter;
            if ( part.includes('mm') ) indexes.month = counter;
            if ( part.includes('yyyy') ) indexes.year = counter;
            counter++;
        }

        formattedDate.push(dateParts[indexes.year]);
        formattedDate.push(dateParts[indexes.month]);
        formattedDate.push(dateParts[indexes.day]);

        return formattedDate?.length > 0 ? formattedDate.join('-') : "";
    };

    const onChange = (selections) => {
        setRenderedDates(selections);
        if (selections.length === 2)
            setDates({
                ...dates,
                sinceDate: formatDate(selections[0]),
                untilDate: formatDate(selections[1]),
            });
    };

    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);

  return (
    <>
        <Helmet>
            <title>Adsnap | Dates</title>
        </Helmet>
            
        { hasCheckOwnership && <PageForty>
            <Alert_ messages={alerts} />
            <PageAlwaysVisible>
                <PageTitle>
                    <h1>{t('Select period')}</h1>
                </PageTitle>
                <PageSubtitle>
                    <p>{t('Choose the desired reporting period for your automated reports. Define the start and end dates to gather data within the specified timeframe. This helps you analyze campaign performance over a specific period and track progress.')}</p>
                </PageSubtitle>
                <Form>
                    <Builder_>
                        <Dates_ onChange={onChange} value={renderedDates} selectRange={true} dateFullCellRender={(date) => date.date()} maxDate={maxDate} />
                    </Builder_>
                </Form>
                <Steps_Actions icon_Grey="Back" icon_Main="Next" id_Main={"AdSnap_Google_Dates_1"} onClick_Grey={() => navigate(`/${lang}/google/clients`)} onClick_Main={() => saveAndNavigate()} text_Grey={t('Back')} text_Main={t('Next')} />
            </PageAlwaysVisible>
            <PageDesktopOnly>
                <PageIllu>
                    <img src="https://genius1071.friktoriaservers.net/doitforme/morning/app/lois/Calendar.svg" />
                </PageIllu>
            </PageDesktopOnly>
        </PageForty> }
        
    </>
  );
};

export default DATES;
